import { FC } from "react";

import { TLatLngTuple } from "@ryde/shared";

import { MapLibreCourseDrawingLine } from "./maplibre-course-drawing-line";
import { MapLibreCourseRouteLine } from "./maplibre-course-route-line";
import { MapLibreEditablePolyline } from "./maplibre-editable-polyline";

interface IMapLibrePolylineMapLayersProps {
  isEditing: boolean;
  isDrawing: boolean;
  isDeletePointMode: boolean;
  finalPositions: TLatLngTuple[];
  drawingPoints: TLatLngTuple[];
  colorValue: string;
  onEditedPositionsChange: (positions: TLatLngTuple[]) => void;
}

/**
 * Which polyline layers the course map shows, and nothing about how any of them look. Vertex edit replaces the
 * route outright (the editor owns its own line so the handles cannot disagree with what is drawn); otherwise
 * the saved route shows, with the in-progress drawing over it while draw mode is live.
 */
export const MapLibrePolylineMapLayers: FC<IMapLibrePolylineMapLayersProps> = ({
  isEditing,
  isDrawing,
  isDeletePointMode,
  finalPositions,
  drawingPoints,
  colorValue,
  onEditedPositionsChange,
}) => {
  if (isEditing) {
    return (
      <MapLibreEditablePolyline
        positions={finalPositions}
        colorValue={colorValue}
        isDeletePointMode={isDeletePointMode}
        onChange={onEditedPositionsChange}
      />
    );
  }

  return (
    <>
      <MapLibreCourseRouteLine
        positions={finalPositions}
        colorValue={colorValue}
        isDrawing={isDrawing}
      />

      {isDrawing && <MapLibreCourseDrawingLine drawingPoints={drawingPoints} />}
    </>
  );
};
